import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

export const AdminHeader = ({ twilioConfigured }) => (
  <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-yellow-400/30">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between h-16">
        <Link to="/" className="flex items-center space-x-2" data-testid="admin-home-link">
          <img src="https://customer-assets.emergentagent.com/job_jetco-electrical/artifacts/x1j92naa_Untitled%20design.png" alt="Jetco Electrical" className="h-10 w-auto" />
          <span className="text-xl font-bold text-white">Admin</span>
        </Link>
        <div className="flex items-center space-x-4">
          <span
            data-testid="twilio-status-badge"
            className={`px-3 py-1 rounded-full text-xs font-medium ${twilioConfigured ? 'bg-green-500/20 text-green-400' : 'bg-yellow-500/20 text-yellow-400'}`}
          >
            {twilioConfigured ? '✓ Twilio Connected' : '⚠ Demo Mode'}
          </span>
          <Link to="/">
            <Button variant="outline" className="border-gray-700 text-gray-300 hover:bg-gray-800" data-testid="admin-back-to-site">Back to Site</Button>
          </Link>
        </div>
      </div>
    </div>
  </header>
);
